import React, { useState, useEffect } from "react";
import { Button, Modal, Table, Spinner } from "react-bootstrap";
import { AiFillDelete } from "react-icons/ai";
import { BiSolidEdit } from "react-icons/bi";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";

const KarleAdminTab = () => {
  // Whitelist state
  const [admins, setAdmins] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editData, setEditData] = useState({});
  const [delData, setDelData] = useState(null);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  const getAdmins = async () => {
    try {
      setIsDataLoading(true);
      const res = await axios.get(`${BASE_URL}/karle/admin/getAll`);
      if (res.data.success) setAdmins(res.data.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    getAdmins();
  }, []);

  const resetForm = () => {
    setName("");
    setMobile("");
  };

  const handleShowAdd = () => {
    resetForm();
    setShowAdd(true);
  };
  const handleCloseAdd = () => setShowAdd(false);

  const handleShowEdit = (item) => {
    setEditData(item);
    setName(item.name || "");
    setMobile(item.mobile || "");
    setShowEdit(true);
  };
  const handleCloseEdit = () => setShowEdit(false);

  const handleShowDelete = (item) => {
    setDelData(item);
    setShowDelete(true);
  };
  const handleCloseDelete = () => setShowDelete(false);

  const addAdmin = async () => {
    try {
      if (!name) return alert("Please add name");
      if (!mobile || String(mobile).length !== 10)
        return alert("Please add a valid 10-digit mobile number");

      setIsLoading(true);
      const res = await axios.post(`${BASE_URL}/karle/admin/add`, {
        name,
        mobile,
      });
      if (res.status === 200) {
        alert("Karle admin added successfully");
        handleCloseAdd();
        await getAdmins();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error adding Karle admin");
    } finally {
      setIsLoading(false);
    }
  };

  const updateAdmin = async () => {
    try {
      if (!name) return alert("Please add name");
      setIsLoading(true);
      const res = await axios.put(`${BASE_URL}/karle/admin/update`, {
        id: editData._id,
        name,
        mobile,
      });
      if (res.status === 200) {
        alert("Updated successfully");
        handleCloseEdit();
        await getAdmins();
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "Error updating Karle admin");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteAdmin = async () => {
    try {
      setIsLoading(true);
      const res = await axios.delete(
        `${BASE_URL}/karle/admin/delete/${delData._id}`,
      );
      if (res.status === 200) {
        alert("Deleted successfully");
        handleCloseDelete();
        await getAdmins();
      }
    } catch (error) {
      console.error(error);
      alert("Error deleting Karle admin");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleBlock = async (item) => {
    try {
      setIsLoading(true);
      await axios.put(`${BASE_URL}/karle/admin/toggleBlock/${item._id}`);
      await getAdmins();
    } catch (error) {
      console.error(error);
      alert("Error updating status");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* Whitelist management */}
      <div className="customerhead p-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 style={{ margin: 0 }}>Karle Login Access</h4>
          <Button variant="success" onClick={handleShowAdd}>
            + Add
          </Button>
        </div>

        {isDataLoading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="oranged" />
          </div>
        ) : (
          <Table
            responsive
            bordered
            style={{ width: "-webkit-fill-available" }}
          >
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {admins.map((item, i) => (
                <tr key={item._id}>
                  <td>{i + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.mobile}</td>
                  <td>
                    <Button
                      size="sm"
                      variant={item.blocked ? "success" : "danger"}
                      onClick={() => toggleBlock(item)}
                      disabled={isLoading}
                    >
                      {item.blocked ? "Unblock" : "Block"}
                    </Button>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "center",
                      }}
                    >
                      <BiSolidEdit
                        className="text-success"
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => handleShowEdit(item)}
                      />
                      <AiFillDelete
                        className="text-danger"
                        style={{ cursor: "pointer", fontSize: "20px" }}
                        onClick={() => handleShowDelete(item)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {admins.length === 0 && (
                <tr>
                  <td colSpan={5}>No Karle admins added yet</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      {/* Add modal */}
      <Modal show={showAdd} onHide={handleCloseAdd} style={{ zIndex: "99999" }}>
        <Modal.Header closeButton>
          <Modal.Title>Add Karle Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Name</label>
              <input
                type="text"
                className="vi_0"
                placeholder="Enter Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Mobile Number</label>
              <input
                type="text"
                className="vi_0"
                placeholder="Enter 10-digit Mobile Number"
                value={mobile}
                maxLength={10}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseAdd}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={addAdmin}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Adding...</span>
              </>
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit modal */}
      <Modal
        show={showEdit}
        onHide={handleCloseEdit}
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Karle Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Name</label>
              <input
                type="text"
                className="vi_0"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="do-sear mt-2">
              <label>Mobile Number</label>
              <input
                type="text"
                className="vi_0"
                value={mobile}
                maxLength={10}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseEdit}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={updateAdmin}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Updating...</span>
              </>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete modal */}
      <Modal
        show={showDelete}
        onHide={handleCloseDelete}
        style={{ zIndex: "99999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-4" style={{ color: "red" }}>
            Remove "{delData?.name}" from Karle login access?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-close-btn"
            variant=""
            onClick={handleCloseDelete}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            className="modal-add-btn"
            variant=""
            onClick={deleteAdmin}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="ms-2">Deleting...</span>
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KarleAdminTab;
